import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles<void, 'text'>({ name: 'AccommodationType', uniqId: 'accommodation-type' })(
	(theme, _, classes) => ({
		accoTypeContainer: {
			display: 'flex',
			flexDirection: 'row',
			gap: theme.spacing.xxsmall,

			[`& .${classes.text}`]: {
				color: theme.body.foreground.color.default,
			},
		},
		text: {
			color: theme.accoTop.link.color.default,
			display: 'flex',
			alignItems: 'center',
			'& svg': {
				color: theme.accoTop.link.color.default,
			},
		},
		icon: {
			color: theme.link.color.light.default,
			verticalAlign: 'top',
		},
	}),
);
